
class CapViewScheduleRequest {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_schedule_request'
}

function create(config) {
  return new CapViewScheduleRequest(config)
}

export default {
  key,
  create,
}
